module.exports = __webpack_public_path__ + "img/json.a9fa5684.svg";